import { Pipe, PipeTransform } from "@angular/core";

/**
 * Removes the trailing file extension from a media name.
 * "Test.jpg" -> "Test", "archive.tar.gz" -> "archive.tar", ".gitignore" -> ".gitignore".
 */
@Pipe({
    name: "stripExtension",
})
export class StripExtensionPipe implements PipeTransform {
    transform(name: string): string {
        if (!name) {
            return name;
        }
        return name.replace(/(?!^)\.[^.\\/]+$/, "");
    }
}
